import * as React from 'react';
import { Paper, styled, useMediaQuery, useTheme } from '@mui/material';
import Column from 'src/frontend-common/components/Column';
import SliderImage1 from 'src/pages/Login/assets/images/login-slide.png';
import SliderImage2 from 'src/pages/Login/assets/images/login-slide2.png';
import SliderImage3 from 'src/pages/Login/assets/images/login-slide3.png';
import Row from 'src/frontend-common/components/Row';
import Carousel from 'react-material-ui-carousel';
import SliderItem from './SliderItem';
import Logo from 'src/frontend-common/components/Logo';

const ColumnWithBackground = styled(Row)(({ theme }) => ({
  color: '#263238',

  [theme.breakpoints.up('md')]: {
    background: 'rgba(255,255,255,1)',
  },
  backgroundColor: 'white',
  backgroundRepeat: 'no-repeat',
  height: '100%',
}));

const MainContent = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: '1fr',
    gridColumnGap: 0,
    gridRowGap: 0,
  },
}));

const Box = styled(Paper)(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: 'white',
  boxShadow: '0 0 0 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(5),
  [theme.breakpoints.up('xl')]: {
    maxWidth: '1002.5px',
    justifySelf: 'center',
    padding: theme.spacing(15),
  },
}));

const RightBox = styled(Paper)(({ theme }) => ({
  width: '100%',
  height: '100%',
  padding: theme.spacing(5),
  boxShadow: 'none',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderRadius: '0',
  background: 'radial-gradient(circle, rgba(83,89,239,1) 40%, rgba(50,53,143,1) 100%)',
  '&>div': {
    '&:last-of-type': {
      maxHeight: '45vw',
      [theme.breakpoints.down('lg')]: {
        maxHeight: '55vw',
      },
    },
  },
  [theme.breakpoints.up('xl')]: {
    justifySelf: 'center',
  },
  '& .indicator': {
    '& button': {
      width: '22px',

      '& svg': {
        width: '19px',
      },
    },
  },
}));

export const LoginItems = [
  {
    title: 'Digital Risk Intelligence',
    subtitle: 'Analyse risk and trust signals behind phone numbers, emails, browsers, devices and ip addresses.',
    image: SliderImage1,
  },
  {
    title: 'Decisioning Engine',
    subtitle: 'Easily deploy out of the box risk-based score cards or build custom models tailored on your use case.',
    image: SliderImage2,
  },

  {
    title: 'Model Insights',
    subtitle: 'Powerful ML tools for detecting suspicious patterns in your signups, logins and transactions.',
    image: SliderImage3,
  },
];

const Layout: React.FC<{
  children: React.JSX.Element | React.JSX.Element[];
}> = ({ children }) => {
  const theme = useTheme();
  const isDesktopUp = useMediaQuery(theme.breakpoints.up('md'));
  const windowRatio = window.innerWidth / window.innerHeight;
  return (
    <ColumnWithBackground grow={true} hAlign="center">
      <MainContent>
        <Box>
          <Column style={{ width: '100%', marginBottom: theme.spacing(1) }} grow={true}>
            <Logo />
          </Column>
          <Column style={{ width: '100%' }} grow={true}>
            {children}
          </Column>
        </Box>

        {isDesktopUp && (
          <RightBox>
            <Column
              grow={true}
              style={{
                width: '100%',
                justifyContent: 'space-around',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <Carousel
                sx={{
                  width: '100%',
                  height: '100%',
                  background: 'transparent',
                  padding: '10px',
                }}
                indicatorContainerProps={{
                  className: 'indicator',
                  style: {
                    position: 'relative',
                    bottom: windowRatio > 0.565 ? '4%' : '6%',
                    zIndex: 999,
                  },
                }}
                height="100%"
                autoPlay={true}
                interval={5000}
                duration={1000}
                animation="slide"
                navButtonsAlwaysInvisible
                stopAutoPlayOnHover={true}
              >
                {LoginItems.map((item, i) => (
                  <SliderItem key={i} item={item} />
                ))}
              </Carousel>
            </Column>
          </RightBox>
        )}
      </MainContent>
    </ColumnWithBackground>
  );
};

export default Layout;
